import type { ReactNode } from 'react'
import { useLocation, useOutlet } from 'react-router-dom'
import { MobileNav } from './MobileNav'
import { Sidebar } from './Sidebar'

export function AppLayout({ children }: { children?: ReactNode }) {
  const location = useLocation()
  const outlet = useOutlet()

  return (
    <div className="flex min-h-screen min-h-[100dvh] bg-background md:h-screen md:min-h-0">
      <Sidebar />
      <main className="min-w-0 flex-1 overflow-x-clip pb-[calc(5rem+env(safe-area-inset-bottom))] md:overflow-x-hidden md:overflow-y-auto md:pb-0">
        <div className="container mx-auto max-w-6xl px-4 py-3 sm:px-6 sm:py-4">
          {children ?? <div key={location.pathname}>{outlet}</div>}
        </div>
      </main>
      <MobileNav />
    </div>
  )
}
